import { PATH } from './constants/router'
import AutomatedTrafficFineNotificationPayment from './page/AutomatedTrafficFineNotificationPayment'
import AutomatedTrafficFineNotificationSuccess from './page/AutomatedTrafficFineNotificationSuccess'
import SplashScreen from './page/SplashScreen'
import TrafficFineCheckConsent from './page/TrafficFineCheckConsent'
import TrafficFineLookupV2 from './page/TrafficFineLookup'
import TrafficFineCheckResultV2 from './page/TrafficFineCheckResult'
import TrafficFineNotificationServices from './page/TrafficFineNotificationServices'
import TrafficFineNotificationVehicles from './page/TrafficFineNotificationVehicles'
import TrafficFinePackageInfo from './page/TrafficFinePackageInfo'
import TrafficFineRegistrationManagement from './page/TrafficFineRegistrationManagement'
import TrafficFineRegistrationManagementFirstTime from './page/TrafficFineRegistrationManagementFirstTime'
import FAQ from './page/TrafficFineFAQ'

export const ROUTERS = {
  splash: {
    path: PATH.HOME,
    component: SplashScreen
  },
  trafficFineLookupV2: {
    path: PATH.TRAFFIC_FINE_LOOKUP,
    component: TrafficFineLookupV2
  },
  trafficFineCheckResultV2: {
    path: PATH.TRAFFIC_FINE_CHECK_RESULT,
    component: TrafficFineCheckResultV2
  },
  trafficFineServices: {
    path: PATH.TRAFFIC_FINE_SERVICES,
    component: TrafficFineNotificationServices
  },
  trafficFineVehicles: {
    path: PATH.TRAFFIC_FINE_VEHICLES,
    component: TrafficFineNotificationVehicles
  },
  automatedTrafficFineNotificationPayment: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_PAYMENT,
    component: AutomatedTrafficFineNotificationPayment
  },
  automatedTrafficFineNotificationSuccess: {
    path: PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_SUCCESS,
    component: AutomatedTrafficFineNotificationSuccess
  },
  trafficFinePackageInfo: {
    path: PATH.TRAFFIC_FINE_PACKAGE_INFO,
    component: TrafficFinePackageInfo
  },
  trafficFineRegistrationManagement: {
    path: PATH.TRAFFIC_FINE_REGISTRATION_MANAGEMENT,
    component: TrafficFineRegistrationManagement
  },
  trafficFineRegistrationManagementFirstTime: {
    path: PATH.TRAFFIC_FINE_REGISTRATION_MANAGEMENT_FIRST_TIME,
    component: TrafficFineRegistrationManagementFirstTime
  },
  trafficFineFaq: {
    path: PATH.TRAFFIC_FINE_FAQ,
    component: FAQ
  },
  trafficFineConsent: {
    path: PATH.TRAFFIC_FINE_CONSENT,
    component: TrafficFineCheckConsent
  }
}
